module.exports = {
	"api": {
		"protocol": "https",
		"host": "api-dlrconnect-test.nl",
		"allowedOrigins": [
			"https://connect.testdlronline.nl"
		],
		"version": "v1",
		"remoteApi": "https://www.testdlronline.nl",
		"url": "https://api-dlrconnect-test.nl/api/v1"
	},
	"gmaps": {
		"key": "AIzaSyCmoAFnejYPQzPsrGy-d4s1yC7FAn6HBrg"
	},
	"website_name": "DLR Online",
	"company_name": "DLR Eurlicon",
	"company_phonenumber": "015 - 256 6666",
	"company_contact_page_url": "https://www.dlr.nl/contact",
	"company_support_email": "support@dlr.nl",
	"no_reply_email": "no-reply@dlr.nl",
	"browser_theme_color": "#ffffff",
	"nav_background_color_primary": "#249b3b",
	"nav_background_color_secondary": "#201751",
	"nav_button_text_color": "#ffffff",
	"nav_button_hover_color_primary": "#e5e5e5",
	"nav_button_hover_color_secondary": "#ffffff",
	"nav_button_hover_text_color": "#000000",
	"nav_border_color": "#000000",
	"public_path_logo": "/frontend/dlr/logo.png",
	"public_path_apple_touch_icon": "/frontend/dlr/apple-touch-icon.png",
	"public_path_favicon_icon_32x32": "/frontend/dlr/favicon-32x32.png",
	"public_path_favicon_icon_16x16": "/frontend/dlr/favicon-16x16.png",
	"public_path_mask_icon": "/frontend/dlr/safari-pinned-tab.svg",
	"public_path_manifest": "/frontend/dlr/manifest.json",
	"public_path_browserconfig": "/frontend/dlr/browserconfig.xml",
	"public_path_favicon": "/frontend/dlr/favicon.ico",
	"mjob_table_head_background_color": "#359b4b",
	"mjob_table_head_text_color": "#ffffff",
	"translation_label_mjob_nen": "custom_report_mmbp_pdf_nen",
	"translation_label_mjob_created_by": "custom_report_mmbp_pdf_created_by",
	"translation_label_mjob_disclaimer": "custom_report_mmbp_pdf_disclaimer",
	"footer_company_link_url": "https://www.dlr.nl",
	"footer_company_link_text": "DLR",
	"app_short_brand_name": "DLR",
	"app_long_brand_name": "DLR",
	"app_name": "Connect",
	"app_extranet_name": "Online",
	"app_navbar_color": "#249b3b",
	"app_favicon": "/:download/config_file?config_file_key=favicon",
	"app_logo": "/:download/config_file?config_file_key=logo",
	"app_icon": "/:download/config_file?config_file_key=apple_touch_icon",
	"widget_tooltip_icon_color": "#201751",
	"widget_tooltip_box_color": "#201751",
	"excel_header_color": "#201751",
	"excel_background_color": "#DCE6F1",
	"portal_url": "https://acc-portal.dlronline.nl",
	"company_testing_email": "keuringen@dlr.nl",
	"connect_url": "https://connect.testdlronline.nl",
	"app_inspection_legend": "/:download/config_file?config_file_key=inspection_legend",
	"iir_url": "https://acc-iir.dlronline.nl",
	"login_color_main": "#4484eb",
	"login_color_second": null,
	"login_color_background": null
}